import Vue from 'vue'
import Vuex from 'vuex'

import { account } from './account.module'
import { usuario } from './usuario.module'
import { notifier } from './notifier.module'
import { dog } from './dog.module'
import { address } from './address.module'
import { phone } from './phone.module'
import { files } from './files.module'
import { inscription } from './inscription.module'
import { menu } from './menu.module'
import { coprop } from './coprop.module'
import { criador } from './criador.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    account,
    usuario,
    notifier,
    dog,
    address,
    phone,
    files ,
    inscription,
    menu,
    coprop,
    criador
  },
  strict: true
})